import {
  login,
  // logout,
  smslogin  
} from '@/api/user'
import {getUsers,getBind} from "@/api/coment"

import {
  getToken,
  setToken,
  removeToken
} from '@/utils/auth'
import {
  getUser,
  setUser,
  removeUser
} from '@/utils/local'

const getDefaultState = () => {
  return {
    token: getToken(),
    userInfo: getUser()
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_USERINFO: (state, userInfo) => {
    state.userInfo = userInfo
    localStorage.setItem("data",JSON.stringify(userInfo))
    setUser(userInfo)
  },

}

const actions = {
  // user login
  login({commit}, userInfo) {  //账号登录
    return new Promise((resolve, reject) => {
      login(userInfo).then(response => {
        commit('SET_TOKEN', response.token)
        setToken(response.token)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  smslogin({commit}, userInfo) {  //短信登录
    return new Promise((resolve, reject) => {
      smslogin(userInfo).then(response => {
        commit('SET_TOKEN', response.token)
        setToken(response.token)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getBind({commit}, userInfo) {  //绑定登录
    return new Promise((resolve, reject) => {
      getBind(userInfo).then(response => {
        commit('SET_TOKEN', response.token)
        setToken(response.token)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },


  // get user info
  getInfo({
    commit,
    state
  }) {
    return new Promise((resolve, reject) => {
      getUsers().then(response => {  //获取个人信息
        // const {
        //   data
        // } = response

        // if (!data) {
        //   reject('Verification failed, please Login again.')
        // }
        commit('SET_USERINFO', response)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // user logout
  logout({
    commit,
    state
  }) {
    return new Promise((resolve, reject) => {
      removeToken() // must remove  token  first
      removeUser()
      commit('RESET_STATE')
      // logout().then(() => {
      //   removeToken() // must remove  token  first
      //   removeUser()
      //   commit('RESET_STATE')
      //   resolve()
      // }).catch(error => {
      //   reject(error)
      // })
    })
  },

  // remove token
  resetToken({
    commit
  }) {
    return new Promise(resolve => {
      removeToken() // must remove  token  first
      commit('RESET_STATE')
      resolve()
    })
  },

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js